module.exports = __webpack_public_path__ + "img/map_Z5.2.B.03.91be80a7.svg";